import createIcon from '../../createIcon';

/**
 * @component @name DonutSmall
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgOS4xNlYyQzYgMi41IDIgNi43OSAyIDEyQzIgMTcuMjEgNiAyMS41IDExIDIyVjE0Ljg0QzEwIDE0LjQzIDkgMTMuMzIgOSAxMkM5IDEwLjY4IDEwIDkuNTcgMTEgOS4xNlpNMTQuODYgMTFIMjJDMjEuNTIgNi4yNSAxOCAyLjQ3IDEzIDJWOS4xNkMxNCA5LjQ2IDE0LjUyIDEwLjE0IDE0Ljg2IDExWk0xMyAxNC44NFYyMkMxOCAyMS41MyAyMS41MiAxNy43NSAyMiAxM0gxNC44NkMxNC41MiAxMy44NiAxNCAxNC41NCAxMyAxNC44NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DonutSmall = createIcon('DonutSmall', [
  [
    'path',
    {
      d: 'M11 9.16V2C6 2.5 2 6.79 2 12C2 17.21 6 21.5 11 22V14.84C10 14.43 9 13.32 9 12C9 10.68 10 9.57 11 9.16ZM14.86 11H22C21.52 6.25 18 2.47 13 2V9.16C14 9.46 14.52 10.14 14.86 11ZM13 14.84V22C18 21.53 21.52 17.75 22 13H14.86C14.52 13.86 14 14.54 13 14.84Z',
      key: '184699',
    },
  ],
]);

export default DonutSmall;
